import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    return { top: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("./views/gw/index.vue"),
    },
    {
      path: "/m",
      component: () => import("./views/gw/index.vue"),
    },
    {
      path: "/home",
      component: () => import("./views/gw/index.vue"),
    },
    {
      path: "/home/m",
      component: () => import("./views/gw/index.vue"),
    },
    {
      path: "/news",
      component: () => import("./views/gw/news.vue"),
    },
    {
      path: "/news/m",
      component: () => import("./views/gw/news.vue"),
    },
    {
      path: "/content",
      component: () => import("./views/gw/content.vue"),
    },
    {
      path: "/content/m",
      component: () => import("./views/gw/content.vue"),
    },
    // 预约
    {
      path: "/pre",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/FB",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/FB/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/GG",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre//GG/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/TT",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/TT/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 备战盟
    {
      path: "/alliance/:type(m)?",
      component: () => import("./views/alliance/index.vue"),
    },
    // 备战盟二期
    {
      path: "/league/:type(m)?",
      component: () => import("./views/league/index.vue"),
    },
    {
      path: "/down/:version",
      component: () => import("./views/down/index.vue"),
      meta: {
        title: "Conquest of Nine kingdoms is now open for pre-registration!",
        description:
          "Conquest of Nine kingdoms is now open for pre-registration!",
      },
    },
    // 协议
    // 东南亚
    {
      path: "/protocol",
      component: () => import("./views/protocol.vue"),
    },
    // 欧美
    {
      path: "/protocol-na",
      component: () => import("./views/na-protocol.vue"),
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  const specialPages = [
    /^\/down(\/.*)?$/,
    /^\/shop(\/.*)?$/,
    /^\/resume(\/.*)?$/,
  ];
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";
  const pcPath = to.path.replace(/\/m$/, "");
  const wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
